import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Children } from 'react';
import { Placeholder } from '../../../../primitives/Select/components/Placeholder/index.js';
import { Container } from '../../../../primitives/Select/components/ValueContainer/components/Container.js';
export const ValueContainer = ({
  children,
  ...restProps
}) => {
  const {
    selectProps,
    getStyles,
    hasValue
  } = restProps;
  const {
    isPinned,
    size,
    controlIcon,
    centered
  } = selectProps;
  return _jsxs(Container
  // @ts-expect-error FIXME
  , {
    // @ts-expect-error FIXME
    reactSelectStyles: getStyles('valueContainer', restProps),
    "data-label": "[]",
    size: size,
    controlIcon: !!controlIcon,
    centered: centered === true,
    children: [(selectProps.isSearchable || isPinned || !hasValue) && _jsx(Placeholder, {
      ...restProps,
      children: selectProps.placeholder
    }), Children.map(children, child => {
      if (child && typeof child === 'object' && 'type' in child && child.type !== Placeholder) {
        return child;
      }
    })]
  });
};